var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.4805H8.5V21.4805C8.5 22.0328 8.05228 22.4805 7.5 22.4805C6.94772 22.4805 6.5 22.0328 6.5 21.4805V20.4805Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 4.48047H5.5L5.5 18.4805H19.5V4.48047ZM5.5 2.48047C4.39543 2.48047 3.5 3.3759 3.5 4.48047V18.4805C3.5 19.585 4.39543 20.4805 5.5 20.4805H19.5C20.6046 20.4805 21.5 19.585 21.5 18.4805V4.48047C21.5 3.3759 20.6046 2.48047 19.5 2.48047H5.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.4805H9.5V20.9805C9.5 21.8089 8.82843 22.4805 8 22.4805C7.17157 22.4805 6.5 21.8089 6.5 20.9805V20.4805Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 4.48047H5.5L5.5 18.4805H19.5V4.48047ZM5.5 2.48047C4.39543 2.48047 3.5 3.3759 3.5 4.48047V18.4805C3.5 19.585 4.39543 20.4805 5.5 20.4805H19.5C20.6046 20.4805 21.5 19.585 21.5 18.4805V4.48047C21.5 3.3759 20.6046 2.48047 19.5 2.48047H5.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwaIcon);
export default __webpack_public_path__ + "static/media/fwa-icon.d9f9a29f6422bf3e518705fd7a878df2.svg";
export { ForwardRef as ReactComponent };